import type { NavigationGuard } from 'vue-router'
import AuthService from '@/services/auth'
import type { RouteMeta } from 'vue-router'
import useAppStore from '@/stores/app'

interface Meta extends RouteMeta {
	permissions: string[]
}

export const authGuard: NavigationGuard = async (to, from, next) => {
	const appStore = useAppStore()
	const authService = new AuthService()
	const permissions = (to.meta as Meta).permissions ?? []

	const isLoggedIn = await authService.isLoggedIn()

	// If not authenticated, run auth
	if (!isLoggedIn) {
		appStore.loading(true)

		const authenticated = await authService.authenticate(to.path)
		if (!authenticated) {
			return next(false)
		}
	}

	if (authService.authorize(permissions)) {
		appStore.loading(false)
		return next()
	} else {
		appStore.loading(false)
		return next(false)
	}
}

export default authGuard
